import React from "react"
import emailjs from 'emailjs-com';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import{ init } from 'emailjs-com';
import { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';

export default function SendMail() {

  const [emailName, setEmailName] = useState('');
  const [emailText, setEmailText] = useState('');
  const [open, setOpen] = React.useState(false);

  function onChangeEmailName(event: any){
    setEmailName(event.target.value);
  }

  function onChangeEmailText(event: any){
    setEmailText(event.target.value);
  }

  function onclickSendMail(){
      init(process.env.GATSBY_USER_ID);

      const emailjsServiceId = process.env.GATSBY_EMAILJS_SERVICE_ID;
      const emailjsTemplateId = process.env.GATSBY_EMAILJS_TEMPLATE_ID;
  
      const templateParams = {
          from_name: emailName,
          message: emailText
      };


      emailjs.send(emailjsServiceId,emailjsTemplateId, templateParams).
      then(()=>{
        setOpen(true);
      });
  }


  return <div className='text-center'>
    <div>
      <TextField 
        id="standard-basic"
        label="your name" 
        value={emailName}
        onChange={onChangeEmailName}
        className='w-52'
      />
    </div>
    <div>
      <TextField
        id="outlined-textarea"
        label=""
        placeholder="some text"
        multiline
        variant="outlined"
        rows={10}
        value={emailText}
        onChange={onChangeEmailText}
        className='w-52'
      />
    </div>
    <Button 
      variant="contained" 
      onClick={() => {onclickSendMail()}}>
        send mail
    </Button>
    <Snackbar 
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open} 
      autoHideDuration={6000}
      onClose={()=>{
        setOpen(false)
      }}
      message="Success mail sending!"
    />
  </div>
}
